<div class="h-full flex flex-col">
  <router-outlet></router-outlet>
</div>

<p-toast position="top-right">
  <ng-template let-message pTemplate="message">
    <span *ngIf="message.severity === 'info'" class="p-toast-message-icon pi pi-info-circle"></span>
    <span *ngIf="message.severity === 'warn'" class="p-toast-message-icon pi pi-exclamation-triangle"></span>
    <span *ngIf="message.severity === 'error'" class="p-toast-message-icon pi pi-times-circle"></span>
    <div class="p-toast-message-text">
      <div class="p-toast-summary">
        <p class="w-96 text-pretty">{{ message.summary }}</p>
      </div>
      <div class="p-toast-detail">
        <p class="w-96 text-pretty">{{ message.detail }}</p>
      </div>
      <div *ngIf="message.data?.button?.click" class="mt-2 flex justify-end">
        <bl-frontend-button
          variant="secondary"
          *ngIf="message.severity === 'info'"
          (onclick)="handleToastButtonClick(message)"
          [text]="message.data.button.text ?? 'Öppna'">
        </bl-frontend-button>
        <bl-frontend-button
          variant="secondary"
          *ngIf="message.severity === 'warn'"
          (onclick)="handleToastButtonClick(message)"
          [text]="message.data.button.text ?? 'Öppna'">
        </bl-frontend-button>
        <bl-frontend-button
          variant="secondary-negative"
          *ngIf="message.severity === 'error'"
          (onclick)="handleToastButtonClick(message)"
          [text]="message.data.button.text ?? 'Öppna'">
        </bl-frontend-button>
      </div>
    </div>
  </ng-template>
</p-toast>
